import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {DeviceActivityLazy} from "@containers/device/containers/deviceActivity/DeviceActivity.lazy";

const DeviceActivityPage = () => {
    return (
        <PageLayout
        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <DeviceActivityLazy/>
            </Suspense>
        </PageLayout>
    )
};

export default DeviceActivityPage;